import { isSupabaseConfigured } from '@/lib/supabase/client';

/**
 * Bandeau affiche tant que le projet Supabase n'est pas branche.
 * Il evite l'illusion d'une application « qui marche » alors qu'aucune donnee
 * reelle n'est disponible.
 */
export function SetupBanner() {
  if (isSupabaseConfigured) return null;

  return (
    <div className="bg-amber-100 px-4 py-2 text-center text-sm text-amber-900">
      <strong>Mode configuration.</strong> Supabase n’est pas connecté : renseignez{' '}
      <code className="rounded bg-amber-200 px-1">VITE_SUPABASE_URL</code> et{' '}
      <code className="rounded bg-amber-200 px-1">VITE_SUPABASE_ANON_KEY</code> dans{' '}
      <code className="rounded bg-amber-200 px-1">.env.local</code>. Aucune donnée réelle n’est
      chargée.
    </div>
  );
}
